import _ from 'lodash';
import event from '~/components/timeline/events/default/Default.vue';
import creativeTeamIcon from '~/components/timeline/events/default/creative_team_icon.png';
import merchantIcon from '~/components/timeline/events/default/merchant_icon.png';
import { USER_GROUPS } from '~/utils/constants.js';

export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  components: {
    event,
  },
  computed: {
    title() {
      const actor = _.get(this.event, 'data.actor');

      if (typeof actor === 'undefined' || actor === null) {
        this.event.data.actor = {
          name: 'System Automation',
        };
      } else if (_.get(this.event, 'data.actor.first_name')) {
        this.event.data.actor.name = _.get(this.event, 'data.actor.first_name');
      }
      if (_.get(this.event, 'data.from_campaign.name')) {
        this.event.data.info.from = _.get(this.event, 'data.from_campaign.name');
      }
      if (_.get(this.event, 'data.to_campaign.name')) {
        this.event.data.info.to = _.get(this.event, 'data.to_campaign.name');
      }

      if (_.get(this.event, 'data.type') === 'rejection') {
        this.event.type = 'Rejection';
      }

      if (_.get(this.event, 'data.type') === 'wip-reject') {
        this.event.type = 'WIP-Reject';
      }

      if (_.get(this.event, 'data.type') === 'brief') {
        this.event.type = 'Brief';
        const commentableType = _.get(this.event, 'data.commentable_type', '') || '';
        if (commentableType.endsWith('\\Campaign')) {
          this.event.type = 'AgentBrief';
        }
      }

      let campaignFlag = '';
      if (_.get(this.event, 'data.campaignEvent')) {
        campaignFlag = this.$t('pos.timeline.campaign-event-flag');
      }
      return `${campaignFlag} ${this.$t(
        `pos.timeline.timeline-events.title.${this.event.type}`,
        { event: this.event.data, userText: this.linkedUserConfig.userText },
      )}`;
    },
    linkedUserConfig() {
      const returnData = {
        icon: null,
        userText: this.$t('pos.timeline.timeline-events.actor-group.system'),
      };

      let user = _.get(this.event, 'data.actor', null);
      if (user === null || _.get(user, 'id', null) === null) {
        user = _.get(this.event, 'data.owner', null);
      }
      if (_.get(user, 'id', null) !== null) {
        returnData.icon = creativeTeamIcon;
        returnData.userText = this.$t('pos.timeline.timeline-events.actor-group.creative-team');
        _.get(user, 'groups', []).forEach(group => {
          if (group.name === USER_GROUPS.CLIENT || group.name === USER_GROUPS.SALES_REP ||
            group.name === USER_GROUPS.SUPER_USER) {
            returnData.icon = merchantIcon;
            returnData.userText = this.$t('pos.timeline.timeline-events.actor-group.merchant');
          }
        });
      }
      return returnData;
    },

    content() {
      return this.$t(
        `pos.timeline.timeline-events.content.${this.event.type}`,
        { event: this.event.data },
      );
    },
    files() {
      const files = [];
      _.forEach(_.get(this.event, 'data.files', []), (value) => {
        const arr = {
          type: value.content_type,
          thumbnail: value.thumbnail,
          poster: value.thumbnail,
          path: value.path,
        };

        if (this.thumbnailIcon(value)) {
          arr.href = value.thumbnail;
        } else {
          arr.href = value.path;
        }
        files.push(arr);
      });
      return files;
    },
    badges() {
      return _.get(this.event, 'data.badges', [])
              .map(b => ({
                text: this.$t(`pos.timeline.timeline-events.badges.${b}`),
              }));
    },
    preview() {
      return _.get(this.event, 'data.data', {});
    },
    customPreview() {
      const mobile = _.get(this.event, 'data.preview_mobile', {});
      const web = _.get(this.event, 'data.preview_web', {});

      return ({
        web,
        mobile,
      });
    },
    createdAt() {
      return _.get(this.event, 'data.created_at', null);
    },
    updatedAt() {
      return _.get(this.event, 'data.updated_at', null);
    },
  },
  methods: {
    thumbnailIcon(file) {
      const ext = this.getFileExtenstion(file.file_name);
      const icons = ['xlsx', 'xls', 'pdf', 'csv', 'txt'];
      return _.includes(icons, ext);
    },
    getFileExtenstion(filename) {
      return filename.split('.').pop().toLowerCase();
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/mixins/timeline-event.js